import { useLayoutContext } from '@/contexts/layout-context';

export const useHasRestaurantStack = () => {
  const { isSmallLayout } = useLayoutContext();

  return !isSmallLayout;
};
